import * as React from 'react';
import Products from './Products';
import ProductCategories from './ProductCategories';
import Discounts from './Discounts/index';

import { Routes, useTypedLocation } from 'routing';
import SetPageTitle from 'components/Portals/SetPageTitle';
import { useSelector } from 'react-redux';
import * as UserSelectors from 'selectors/UserSelectors';
import { useTranslation } from 'services/localization/useTranslation';
import GeneralSettings from './GeneralSettings';
import TabContainer from 'components/nav/TabContainer';
import Container from 'components/Container';
import { useHasFeature } from 'hooks/useHasFeature';
import SetPageNavAction from 'components/Portals/SetPageNavAction';

const ProductsTabs = () => {
	const isAdmin = useSelector(UserSelectors.isAdmin);

	const { t } = useTranslation();
	const { hasFeature } = useHasFeature();
	const { state } = useTypedLocation();

	return (
		<>
			<SetPageTitle
				title={t('products.catalog', 'Catalog')}
				priority={1}
				styling={{ fluid: true }}
			/>
			{state?.from === Routes.HOME_VIEW && (
				<SetPageNavAction
					priority={2}
					backAction={{
						to: Routes.HOME_VIEW,
						title: t('common:actions.home', 'Home'),
					}}
					quickLinks={[]}
				/>
			)}
			<Container fluid>
				<TabContainer
					basePath={Routes.CATALOG}
					tabs={[
						{
							label: t('products.products'),
							path: 'products',
							component: Products,
						},
						{
							label: t('common:marketing.categories'),
							path: 'categories',
							component: ProductCategories,
						},
						{
							label: t('discount.discounts', 'Discounts'),
							path: 'discounts',
							component: Discounts,
							hidden: !hasFeature('DISCOUNTS', {
								scope: 'user',
							}),
							locked: !hasFeature('DISCOUNTS', {
								scope: 'shop',
							}),
						},
						{
							label: t('shop.generalSettings', 'General settings'),
							path: 'settings',
							component: GeneralSettings,
							hidden: !hasFeature('DIN_SETTINGS') || !isAdmin,
						},
					]}
				/>
			</Container>
		</>
	);
};

export default ProductsTabs;
